import React, { Component } from "react";
import { CSSTransition } from "react-transition-group";
import styleObj from "./style.module.scss";
import "./style.scss";

export default class pendantBg extends Component {
  constructor(props) {
    super(props);
    this.state = {
      init: false,
    };
  }
  render() {
    let { init } = this.state;
    let { width, left, top, bottom, url } = this.props;
    let getUnit = (num) => (num ? num + "px" : "auto");
    return (
      <div
        className={styleObj["pendant-wrap"]}
        style={{
          width: getUnit(width),
          top: getUnit(top),
          left: getUnit(left),
          bottom: getUnit(bottom),
        }}
      >
        <CSSTransition in={init} classNames="fade" timeout={1200} unmountOnExit>
          <img src={url} alt="" />
        </CSSTransition>
      </div>
    );
  }
  componentDidMount() {
    this.setState({ init: true });
  }
}
